"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _get = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/get.js").default;
var _getPrototypeOf = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongFontSizeCSSValidator = void 0;
var _helpers = require("../helpers");
var _LongSizeCSSPropertyValidator = require("./LongSizeCSSPropertyValidator");
var LongFontSizeCSSValidator = /*#__PURE__*/function (_LongSizeCSSPropertyV) {
  _inherits(LongFontSizeCSSValidator, _LongSizeCSSPropertyV);
  var _super = _createSuper(LongFontSizeCSSValidator);
  function LongFontSizeCSSValidator() {
    _classCallCheck(this, LongFontSizeCSSValidator);
    return _super.apply(this, arguments);
  }
  _createClass(LongFontSizeCSSValidator, [{
    key: "computeSize",
    value: function computeSize(value, unit) {
      if (unit === '%') {
        return this.computeEmSize(value / 100);
      }
      return _get(_getPrototypeOf(LongFontSizeCSSValidator.prototype), "computeSize", this).call(this, value, unit);
    }
  }, {
    key: "normalizeRawInlineCSSValue",
    value: function normalizeRawInlineCSSValue(value) {
      if ((0, _helpers.lookupRecord)(this.config.absoluteFontSizesPixelMap, value)) {
        return this.config.absoluteFontSizesPixelMap[value];
      }
      if ((0, _helpers.lookupRecord)(this.config.relativeFontSizesCoefficientMap, value)) {
        return this.computeEmSize(this.config.relativeFontSizesCoefficientMap[value]);
      }
      return _get(_getPrototypeOf(LongFontSizeCSSValidator.prototype), "normalizeRawInlineCSSValue", this).call(this, value);
    }
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      return this.normalizeInlineCSSValue(value);
    }
  }]);
  return LongFontSizeCSSValidator;
}(_LongSizeCSSPropertyValidator.LongSizeCSSPropertyValidator);
exports.LongFontSizeCSSValidator = LongFontSizeCSSValidator;